module.exports = __webpack_public_path__ + "img/map_icon.70bec5c6.png";